// report-common
import { getFilterParamsFromColumnSettings } from '../../../report-common';
// feature inspections
import { columnSettings } from './table-settings';
//////////////////////////////////////////////////

export const FILTER_PARAMS = getFilterParamsFromColumnSettings(columnSettings);
